<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <div v-for="(group) in allData" :key="group.key" style="margin-top: 30px; margin-bottom:20px;">
      <h3>{{group.key}}</h3>

      <table class="hiaTable printable-by-code" style="margin-top: 20px;">
        <thead>
          <tr>
            <th>Code</th>
            <th>Description</th>
            <th>Occur.</th>
            <th>No<br>Changes</th>
            <th>Del.</th>
            <th>Revised<br>From</th>
            <th>Accuracy<br>Rate</th>
            <th>Adds</th>
            <th>Revised<br>To</th>
            <th>% of<br>Missed</th>
          </tr>
        </thead>
        <tr v-for="item in group.data" :key="item.key">
          <td class="textAlignLeft"> {{item.code}} </td>
          <td> {{item.description}} </td>
          <td> {{item.totalRecords}} </td>
          <td> {{item.numOfNoRec}} </td>
          <td> {{item.numOfDeletions}} </td>
          <td> {{item.revisedFromCount}} </td>
          <td> {{formatPercentage(item.cptCodes)}} </td>
          <td> {{item.numOfAdditions}} </td>
          <td> {{item.revisedToCount}} </td>
          <td> {{formatPercentage(item.percentOfMissedOpportunities)}} </td>
        </tr>
        <tr class="strong emphasis">
          <td class="textAlignLeft">Total</td>
          <td class="textAlignLeft"></td>
          <td>{{getSummaries(group.data)[2]}}</td>
          <td>{{getSummaries(group.data)[3]}}</td>
          <td>{{getSummaries(group.data)[4]}}</td>
          <td>{{getSummaries(group.data)[5]}}</td>
          <td>{{getSummaries(group.data)[6]}}</td>
          <td>{{getSummaries(group.data)[7]}}</td>
          <td>{{getSummaries(group.data)[8]}}</td>
          <td>{{getSummaries(group.data)[9]}}</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'

  export default {
    name: 'OP_SIPrintable',
    mixins: [hiaFilters, money, dashboardHelper],
    props: ['ascTableIds', 'codeTypes'],
    components: {
    },
    data: function () {
      return {
        allData: [],
        tableData: [],
        filterCriteria: '',
        loading: false,
        summaryRow: {},
        detailsHeader: ''
      }
    },
    methods: {
      async getData() {
        const payload = {
          ascTableIds: this.ascTableIds,
          codeTypes: this.codeTypes,
          includeAccts: true,
          statType: 'test'
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/dashboard/opByCPT?cptType=3`, payload)
          this.allData = response.data.data
          this.tableData = response.data.data
          this.attachMissedOpportunityPctToGroups(this.allData, 'numOfAdditions', 'revisedToCount')
        } catch (err) {
          this.allData = []
          this.tableData = []
        } finally {
          this.$nextTick(() => {
            // this.$refs.dxTable.doLayout()
            this.loading = false
          })
        }
      },
      getSummaries(data) {
        const param = {
          columns: [
            { property: 'code' },
            { property: 'description' },
            { property: 'totalRecords' },
            { property: 'numOfNoRec' },
            { property: 'numOfDeletions' },
            { property: 'revisedFromCount' },
            { property: 'cptCodes', label: 'Accuracy Rate' },
            { property: 'numOfAdditions' },
            { property: 'revisedToCount' },
            { property: 'percentOfMissedOpportunities' }
          ],
          data: data
        }
        return this.getSummary(param)
      },
      cellClasses({ row, column, rowIndex, columnIndex }) {
        if (column.property === 'code' || column.property === 'description' || column.property === 'codeDesc') {
          return 'textAlignLeft'
        }
        if (column.property === 'details') {
          return 'textAlignCenter'
        }
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl'])
    },
    mounted: async function () {
      await this.getData()
    },
    watch: {
      ascTableIds: async function () {
        await this.getData()
      },
      codeTypes: async function () {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
.totalsTable {
  border-spacing: 0px;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.totalsTable td {
  padding: 13px;
}
</style>
